import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useRxCollection } from 'rxdb-hooks';

import { useMst } from '../../mobx-models/Root';
import { sentryCaptureException } from '../../utilities';
import { WorkPackageStatus } from '../../utilities/enums';
import { RxdbCollectionName } from '../rxdbCollectionName';
import { WorkPackagesCollection, WorkPackagesDocument } from './queryBuilder';

export const useWorkPackages = () => {
  const workPackagesCollection: WorkPackagesCollection = useRxCollection(
    RxdbCollectionName.WORK_PACKAGES,
  );
  const history = useHistory();
  const { SiteDiscipline } = useMst();
  const [workPackagesInitialized, setWorkPAckagesInitialized] = useState<boolean>(false);

  useEffect(() => {
    if (workPackagesCollection) setWorkPAckagesInitialized(true);
  }, [workPackagesCollection]);

  const getWorkPackages = async (): Promise<WorkPackagesDocument[]> => {
    if (!workPackagesCollection) return [];
    let workPackages: WorkPackagesDocument[];

    try {
      const site = SiteDiscipline.siteId;
      const discipline = SiteDiscipline.disciplineId;
      const queryObj = {
        selector: {
          $and: [{ site }, { discipline }, { workPackageStatusId: { $lt: 4 } }],
        },
      };

      workPackages = await workPackagesCollection?.find(queryObj).exec();
      return workPackages;
    } catch (error) {
      console.log('🚀 ~ file: useWorkPackages.ts ~ line 30 ~ getWorkPackages ~ error', error); // eslint-disable-line no-console
      // console logs will be removed once sentry implementation is done
      sentryCaptureException(error, '~ file: useWorkPackages.tsx ~ line 30 ~ getWorkPackages ~');
      throw error;
    }
  };

  const setWorkPackages = async (workPackageId: string, status: number) => {
    try {
      if (workPackagesCollection) {
        const updated = await workPackagesCollection
          .findOne({
            selector: {
              workPackageId: { $eq: workPackageId },
            },
          })
          .update({
            $set: {
              workPackageStatusId: status,
            },
          });
        if (updated?.workPackageStatusId === WorkPackageStatus.COMPLETED) {
          history.push('/work-packages');
        }
        return updated;
      }
    } catch (error) {
      console.log('🚀 ~ file: useWorkPackages.ts ~ line 55 ~ setWorkPackages ~ error', error); // eslint-disable-line no-console
      // console logs will be removed once sentry implementation is done
      sentryCaptureException(error, '~ file: useWorkPackages.tsx ~ line 55 ~ setWorkPackages ~');
      throw error;
    }
  };

  const setInspectionCountInWorkPackage = async (workPackageId: string) => {
    try {
      if (workPackagesCollection) {
        const updated = await workPackagesCollection
          .findOne({
            selector: {
              workPackageId,
            },
          })
          .update({
            $inc: {
              noOfInspections: -1,
            },
          });
        return updated;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(
        '🚀 ~ file: useWorkPackages.ts ~ line 80 ~ setInspectionCountInWorkPackage ~ error',
        error,
      );
      // console logs will be removed once sentry implementation is done
      sentryCaptureException(
        error,
        '~ file: useWorkPackages.tsx ~ line 80 ~ setInspectionCountInWorkPackage ~',
      );
    }
  };

  return {
    workPackagesInitialized,
    getWorkPackages,
    workPackagesCollection,
    setWorkPackages,
    setInspectionCountInWorkPackage,
  };
};

export default {};
